import { useEffect, useState } from "react";
import ImageSlider, { Slide } from "react-auto-image-slider";
import { Col, Container, Image, Row, Table } from "react-bootstrap";
import { Map, MapMarker } from "react-kakao-maps-sdk";
import SwiperCore from "swiper";
import "swiper/css";
import { Mousewheel } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import logo from "./assets/images/black_logo.mp4";
import dentalMaxImage from "./assets/images/dentalmax.png";
import hsImage from "./assets/images/hs.png";
import iactImage from "./assets/images/iact.png";
import img1 from "./assets/images/img1.png";
import img2 from "./assets/images/img2.png";
import img3 from "./assets/images/img3.png";
import img4 from "./assets/images/img4.png";
import mdxImage from "./assets/images/mdx.png";
import newsysImage from "./assets/images/newsys.jpg";
import patternnImage from "./assets/images/patternn.png";
import sungwooImage from "./assets/images/sungwoo.png";

function BrowserView() {
    const [swiper, setSwiper] = useState<SwiperCore>();

    useEffect(() => {
        window.TypeHangul.type("#vision", {
            intervalType: 50,
            humanize: 0.5
        });
    }, []);

    return (
        <>
            <Container className="fixed-top top-navbar pt-5">
                <Row>
                    <Col xs={9}>
                        <video muted autoPlay loop preload="auto">
                            <source src={logo} type="video/mp4" />
                        </video>
                    </Col>
                    <Col xs={1} className="menu-bar" style={{ cursor: "pointer" }} onClick={() => swiper?.slideTo(1)}>
                        About Us
                    </Col>
                    <Col xs={1} className="menu-bar" style={{ cursor: "pointer" }} onClick={() => swiper?.slideTo(3)}>
                        Solutions
                    </Col>
                    <Col xs={1} className="menu-bar" style={{ cursor: "pointer" }} onClick={() => swiper?.slideTo(4)}>
                        Location
                    </Col>
                </Row>
            </Container>
            <Swiper
                onSwiper={setSwiper}
                className="h-100"
                spaceBetween={0}
                slidesPerView={1}
                direction={"vertical"}
                mousewheel={true}
                modules={[Mousewheel]}
            >
                <SwiperSlide>
                    <Container className="d-flex flex-column pt-5 h-100">
                        <Row className="flex-grow-1 d-flex align-items-start justify-content-center text-center backgroundImage">
                            <Col id="vision" className="vision">
                                세상의 가치와 사람, 정보기술을 연결하는 매듭
                            </Col>
                        </Row>
                    </Container>
                </SwiperSlide>
                <SwiperSlide>
                    <Container className="d-flex flex-column pt-5 h-100">
                        <Row className="flex-grow-1 d-flex align-items-center justify-content-center text-center">
                            <Col xs={6}>
                                <ImageSlider effectDelay={1000} autoPlayDelay={4000}>
                                    <Slide>
                                        <Image src={img1} height={300} />
                                    </Slide>
                                    <Slide>
                                        <Image src={img2} height={300} />
                                    </Slide>
                                    <Slide>
                                        <Image src={img3} height={300} />
                                    </Slide>
                                    <Slide>
                                        <Image src={img4} height={300} />
                                    </Slide>
                                </ImageSlider>
                            </Col>
                            <Col xs={6}>
                                <Row className="mb-4">
                                    <Col xs={4} className="subtitle">
                                        History
                                    </Col>
                                    <Col xs={8}></Col>
                                </Row>
                                <Row>
                                    <Col xs={4}>
                                        2025년
                                    </Col>
                                    <Col xs={8} className="text-start">
                                        2025.08. 익명 기반 개인키 복원 기술 특허 등록
                                    </Col>
                                </Row>
                                <Row className="mt-2">
                                    <Col xs={4}>
                                    </Col>
                                    <Col xs={8} className="text-start">
                                        2025.04. 혁신성장유형 벤처기업인증
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col xs={4}>
                                        2024년
                                    </Col>
                                    <Col xs={8} className="text-start">
                                        2024.12. (주)성우 압력측정기 관리프로그램 개발
                                    </Col>
                                </Row>
                                <Row className="mt-2">
                                    <Col xs={4}>
                                    </Col>
                                    <Col xs={8} className="text-start">
                                        2024.07. 희성산업 로봇 용접 생산·관리시스템 개발
                                    </Col>
                                </Row>
                                <Row className="mt-2">
                                    <Col xs={4}>
                                    </Col>
                                    <Col xs={8} className="text-start">
                                        2024.05. (주)엠디엑스 무인카페 키오스크 프로그램 개발
                                    </Col>
                                </Row>
                                <Row className="mt-2">
                                    <Col xs={4}>
                                    </Col>
                                    <Col xs={8} className="text-start">
                                        2024.03. 연구전담부서 설립인가
                                    </Col>
                                </Row>
                                <Row className="mt-2">
                                    <Col xs={4}>
                                    </Col>
                                    <Col xs={8} className="text-start">
                                        2024.02. 대구여성인력개발센터 업무협약 체결
                                    </Col>
                                </Row>
                                <Row className="mt-2">
                                    <Col xs={4}>
                                    </Col>
                                    <Col xs={8} className="text-start">
                                        2024.01. (주)엠디엑스 업무제휴 협약 체결
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col xs={4}>
                                        2023년
                                    </Col>
                                    <Col xs={8} className="text-start">
                                        2023.11. 주식회사 노트랩 법인 설립
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Container>
                </SwiperSlide>
                <SwiperSlide>
                    <Container className="d-flex flex-column pt-5 h-100">
                        <Row className="flex-grow-1 d-flex align-items-center justify-content-center text-center">
                            <Col>
                                <Row className="text-start mb-3">
                                    <Col className="subtitle">
                                        Partner Company
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="pt-5 pb-5 all-border">
                                        <Row>
                                            <Col>
                                                <Image src={mdxImage} height={50} />
                                            </Col>
                                            <Col>
                                                <Image src={sungwooImage} height={50} />
                                            </Col>
                                            <Col>
                                                <Image src={newsysImage} height={50} />
                                            </Col>
                                        </Row>
                                        <Row className="mt-5">
                                            <Col>
                                                <Image src={iactImage} height={35} />
                                            </Col>
                                            <Col>
                                                <Image src={dentalMaxImage} height={50} />
                                            </Col>
                                            <Col>
                                                <Image src={hsImage} height={50} />
                                            </Col>
                                        </Row>
                                        <Row className="mt-4">
                                            <Col>
                                                <Image src={patternnImage} height={50} />
                                            </Col>
                                            <Col>
                                            </Col>
                                            <Col>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Container>
                </SwiperSlide>
                <SwiperSlide>
                    <Container className="d-flex flex-column pt-5 h-100">
                        <Row className="flex-grow-1 d-flex align-items-center justify-content-center text-center">
                            <Col>
                                <Row className="text-start mb-3">
                                    <Col className="subtitle">
                                        Solutions
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="p-5 all-border">
                                        <Table>
                                            <thead>
                                                <tr>
                                                    <th>제품</th>
                                                    <th>기능</th>
                                                    <th>월 단가(원)</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>KD-MMS</td>
                                                    <td>가공 공정 모니터링 시스템</td>
                                                    <td>₩1,440,000</td>
                                                </tr>
                                                <tr>
                                                    <td>KD-OMS</td>
                                                    <td>조립 공정 관리 시스템</td>
                                                    <td>₩1,440,000</td>
                                                </tr>
                                                <tr>
                                                    <td>KD-MES</td>
                                                    <td>공정 관리 시스템</td>
                                                    <td>₩1,440,000</td>
                                                </tr>
                                                <tr>
                                                    <td>KD-WMS</td>
                                                    <td>배선 공정 관리 시스템</td>
                                                    <td>₩1,440,000</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Container>
                </SwiperSlide>
                <SwiperSlide>
                    <Container className="d-flex flex-column pt-5 h-100">
                        <Row className="flex-grow-1 d-flex align-items-center justify-content-center">
                            <Col className="h-50">
                                <Row className="text-start mb-3">
                                    <Col className="subtitle">
                                        Location
                                    </Col>
                                </Row>
                                <Row className="h-100 gap-5 ps-2">
                                    <Col xs={6} className="pt-2 pb-2 all-border h-100">
                                        <Map
                                            center={{ lat: 35.83527, lng: 128.68236 }}
                                            style={{ width: "100%", height: "100%" }}
                                            level={3}
                                        >
                                            <MapMarker
                                                position={{ lat: 35.83527, lng: 128.68236 }}
                                            />
                                        </Map>
                                    </Col>
                                    <Col xs={5} className="pt-5 pb-5 ps-5 all-border h-100">
                                        <Row>
                                            <Col className="paragraph-title">
                                                HeadQuater
                                            </Col>
                                        </Row>
                                        <Row className="mt-2">
                                            <Col>
                                                대구광역시 수성구 알파시티1로 160, DNEX 602호
                                            </Col>
                                        </Row>
                                        <Row className="mt-5">
                                            <Col className="paragraph-title">
                                                Contact Us
                                            </Col>
                                        </Row>
                                        <Row className="mt-2">
                                            <Col>
                                                Tel: 053-710-4800
                                            </Col>
                                        </Row>
                                        <Row className="mt-2">
                                            <Col>
                                                Mail: knot@knotlab.kr
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row className="top-border pt-3 mb-3">
                            <Col>
                                © 2025. Knotlab Inc. All rights reserved.
                            </Col>
                        </Row>
                    </Container>
                </SwiperSlide>
            </Swiper>
        </>
    );
}

export default BrowserView;